import { Common, Header, color } from '@stockbit/ui';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import generateNavBar from 'utils/navbar';
import { selectors } from 'lib/entities/profile';
import useTradingAccount from 'hooks/useTradingAccount';
import RealTradingMobile from '../RealTrading/Mobile';
import VirtualTradingMobile from '../VirtualTrading/Mobile';
import InitialTradingMobile from '../InitialTrading/Mobile';
import ExpandMenuOpen from './ExpandMenuOpen';
import { PopoverNavbarContainer, IconClose, Grid } from './styled';
import ReloadHandler from './ReloadHandler';

const { Iconmoon, IconWrapper, Text } = Common;
const { PopoverCustom: PopoverMobile } = Header;

function componentTrigger(isButtonActive) {
  if (isButtonActive) {
    return (
      <IconClose size="60px">
        <Iconmoon size="25px" className="icon-compose_close" />
      </IconClose>
    );
  }
  return (
    <IconWrapper size="60px">
      <ExpandMenuOpen />
    </IconWrapper>
  );
}

export const Mobile = () => {
  const router = useRouter();
  const { data } = useSelector(selectors);
  const { isRealTrading, isVirtualTrading, tradingType } = useTradingAccount();

  const renderTradingPopup = () => {
    if (!tradingType) return <InitialTradingMobile />;
    if (isRealTrading) return <RealTradingMobile />;
    if (isVirtualTrading) return <VirtualTradingMobile />;
    return <div />;
  };

  return (
    <PopoverMobile componentTrigger={componentTrigger}>
      <PopoverNavbarContainer>
        {renderTradingPopup()}
        <Grid>
          {generateNavBar(data).map((item) => (
            <ReloadHandler
              href={item.href}
              label={item.label}
              isMobile
              data-cy={item['data-cy']}
            >
              <Iconmoon
                className={item.logoMobile}
                color={item.matcher(router) ? color.primary : color.dimgray}
                size="24px"
              />
              <Text
                as="a"
                size="11px"
                align="center"
                color={item.matcher(router) ? color.primary : color.dimgray}
              >
                {item.label}
              </Text>
            </ReloadHandler>
          ))}
        </Grid>
      </PopoverNavbarContainer>
    </PopoverMobile>
  );
};

export default Mobile;
